import React from 'react';
import { portalCopy } from '../copy';
import type { BusinessAnalytics } from '../types';

type AnalyticsChartPlaceholderProps = {
  analytics: BusinessAnalytics;
};

const AnalyticsChartPlaceholder: React.FC<AnalyticsChartPlaceholderProps> = ({ analytics }) => {
  const max = Math.max(...analytics.plansByMonth.map((m) => m.value), 1);

  return (
    <div className="rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white p-6">
      <h3 className="font-jakarta text-sm font-bold text-[#2a0f2a]">{portalCopy.business.chartTitle}</h3>
      <div className="mt-6 flex items-end justify-between gap-2 sm:gap-4" style={{ minHeight: 160 }}>
        {analytics.plansByMonth.map((month) => (
          <div key={month.label} className="flex flex-1 flex-col items-center gap-2">
            <div className="flex w-full flex-1 items-end">
              <div
                className="w-full rounded-t-lg bg-chisme-primary/80 transition-all"
                style={{ height: `${(month.value / max) * 140}px` }}
                title={`${month.value} planes`}
              />
            </div>
            <span className="font-jakarta text-xs font-medium text-[#5a3158]">{month.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsChartPlaceholder;
